import React from 'react';
import { Row, Button, Col } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import '../../assets/css/pages/page-misc.css';

function Error404() {
  const urlLogo = require(`./../../assets/images/pages/logo-dpt.png`).default
  const urlBgError = require(`./../../assets/images/pages/error.svg`).default

  return (
    <div className="misc-wrapper error-page">
      <a className="brand-logo" href="javascript:void(0);">
        <img className='img-fluid' style={{width: 65}} src={urlLogo} alt='Login V2' />
        <h2 className="brand-text text-primary ml-1 pt-1 text-success">PT. DHARMA POLIMETAL</h2>
      </a>
      <div className="misc-inner mt-0 p-2 p-sm-3">
          <div className="w-100 text-center">
              <h2 className="mb-1">Page Not Found 🕵🏻‍♀️</h2>
              <p className="mb-2">Oops! 😖 The requested URL was not found on this server.</p>
              <a className="btn btn-success mb-2 btn-sm-block" href={sessionStorage.getItem('redirect')}>Back to home</a>
              <img className="img-fluid" src={urlBgError} alt="Error page" />
          </div>
      </div>
    </div>
    // <Row type="flex" justify="center" align="middle">
    //   <Col>
    //     <div>
    //       <div>
    //         ABCD
    //       </div>
    //     </div>
    //     <Row type="flex" justify="center">
    //       <Col>
    //         <p>Page you visited seems like not found</p>
    //       </Col>
    //     </Row>
    //     <Row type="flex" justify="center" gutter={0}>
    //       <Col>
    //         <Link to={sessionStorage.getItem('redirect')}>
    //           <Button type="primary">
    //             <HomeOutlined />
    //             Back to Home
    //           </Button>
    //         </Link>
    //       </Col>
    //     </Row>
    //   </Col>
    // </Row>
  );
}

export default Error404;
